<script setup>
import proinfo from "@/components/common/Productinfo.vue";
import Alert   from  '@/components/common/Alert.vue';
import axios  from "axios";
axios.defaults.withCredentials = true;
axios.defaults.crossDomain = true;
</script>
<template>
    <v-card
        flat
        outlined
        class="mb-3"
    >
        <v-card-title class="pb-2">
                <h2 class="titlelabel">前後2週間の状況</h2>
        </v-card-title>
<v-card-text
	v-if="status_list.length==0 && soon_list.length == 0"
	min-height="300px"
>
<Alert
    message="編集で新規作成するか、既存の文書に条件にあった項目を設定してください。"
    messagetitle="リリース文書は登録されていません"
    messagetype="0"
    blockheight="300px"
/>
<div
    style="width:100%;text-align:center;"
>
    <v-btn
        to="/edit"
    >
        編集画面へ進む
    </v-btn>
</div>
</v-card-text>
        <v-card-text class="pb-0" else>
			<v-list v-if="status_list.length!=0">
				<v-list-item v-for="item,index in status_list" :key="index" class="mt-1">
					<v-row>
						<v-col >
							<span style="font-size:1.7rem;font-weight:bold;">{{ item.product_name }}</span>
						</v-col>
						<v-col cols="3">
							<span style="font-size:1.5rem;font-weight:bold">{{ item.therm }}</span>
						</v-col>
						<v-col cols="2">
							<span style="font-size:1.5rem;font-weight:bold">{{ item.cnt }}件</span>
						</v-col>
					</v-row>
				</v-list-item>
			</v-list>
			<v-divider v-if="status_list.length!=0 && soon_list.length != 0" class="mb-3" />
			<v-card flat v-if="soon_list.length != 0">
					<v-card-title class="px-2"><h2 style="margin:2px;"><v-icon color="#E11D31" class="mr-3">mdi-timer-star-outline</v-icon>もうすぐ配信日</h2></v-card-title>
					<v-card-text style="font-size:1.3rem;color:black;">配信準備はお済みですか？ステータスを確認してください。</v-card-text>
			<v-card-text>
				<v-row v-for="item,index in soon_list" :key="index" class="confirm">
					<v-col cols="2"><span class="statusblock">{{ item.status }}</span></v-col>
					<v-col cols="8" class="px-2">
						<h2><a href="javascript:void(0)" @click="movedoc(item.id)">{{ item.title }}</a></h2>
						<p><span style="font-weight:bold;margin-right:5px">配信日</span>{{ item.release_date }}</p>
					</v-col>
					<v-col cols="2" class="px-2"><span class="timer">あと<span style="font-size:2rem;font-weight:bold;margin-left:5px;margin-right:5px;">{{ item.hours }}</span>時間</span></v-col>
				</v-row>
			</v-card-text>
			</v-card>
        </v-card-text>
    <proinfo
        ref="pi"
    >
    </proinfo>

        <v-card-actions
            class="pt-0"
        >
            <v-spacer />
            <v-btn
                to="/list"
                class="mr-2"
                text
                dense
            >
                <v-icon color="red" class="mr-2">mdi-format-list-bulleted</v-icon>リリース一覧へ
            </v-btn>
        </v-card-actions>
    </v-card>
</template>
<script>
export default {
    data : function(){
        return {
			status_list : [],
			soon_list : [],
        };
    },
    methods : {
        proinfo_open    : function(){
            this.$refs.pi.open();
        },
		homesummary : async function(){
            let params = new URLSearchParams();
            await axios.post("https://qlipper.jp/api/release/get_home",params)
            .then(response => {
                this.status_list  = response.data.list;
                this.soon_list  = response.data.soon;
            }).catch((error) => {
                window.location.href = 'https://qlipper.jp/login';
                console.error('失敗です', error);
            });
		},
		movedoc : function(doc_id){
            this.doc_id=doc_id;
            this.$router.push({name: 'Edit', params: {selected_id: this.doc_id}});
		},
    },
	created : function(){
		this.homesummary();
	},
}
</script>
<style>
.statusblock{
	display : block;
	font-size:1.3rem;
	color : #284C79;
	width : 100px;
	border-radius : 7px;
	font-weight : bold;
	border : 2px solid #284C79;
	align-items : center;
	text-align: center;
	padding : 5px;
}
.confirm{
	align-items : center;
	color : black;
}
.confirm h2{
	margin :0px;
	white-space : nowrap;
	overflow: hidden;
	width :calc(100%*0.9);
	text-overflow: ellipsis;
}

.confirm p{
	margin:10px 0 0 0;
	padding-left : 5px;
	font-size:1.3rem;
}

.timer{
	color : #0072BB;
	font-size : 1.4rem;
}
</style>
